export class CaseNotLockedError extends Error {
    constructor(message?: string) {
        super(message);
    }
}
